// store object for scheduler, new instances should use a new storeKey
// if in the future you need more than one scheduler component pass
// a teacherId, adminId, etc as the storeKey.
export const Store = {}